"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProviderConsumerBackwardCompatible = require("../ThemeProvider/ThemeProviderConsumerBackwardCompatible");
var _system = require("@wix/wix-ui-icons-common/system");
var _generateDataAttr = require("../utils/generateDataAttr");
var _constants = require("./constants");
var _CloseButtonSt = require("./CloseButton.st.css");
var _ButtonCore = _interopRequireDefault(require("../Button/ButtonCore"));
var _excluded = ["skin", "size", "className", "dataHook", "children"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/CloseButton/CloseButton.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var childSize = '18px';
class CloseButton extends _react.PureComponent {
  _renderCloseIcon(Icon, size) {
    var CloseIcon;
    if (size === _constants.SIZES.small) {
      // fallback to Close icon if children not provided (current behavior)
      CloseIcon = /*#__PURE__*/_react.default.createElement(Icon, {
        "data-hook": "close",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 19
        }
      });
    } else if (size === _constants.SIZES.medium) {
      CloseIcon = /*#__PURE__*/_react.default.createElement(Icon, {
        "data-hook": "close-medium",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 19
        }
      });
    } else {
      CloseIcon = /*#__PURE__*/_react.default.createElement(Icon, {
        "data-hook": "close-large",
        size: "12",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 19
        }
      });
    }
    return CloseIcon;
  }
  render() {
    var _this$props = this.props,
      {
        skin,
        size,
        className,
        dataHook,
        children
      } = _this$props,
      rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    return /*#__PURE__*/_react.default.createElement(_ButtonCore.default, (0, _extends2.default)({}, rest, {
      className: (0, _CloseButtonSt.st)(_CloseButtonSt.classes.root, {
        skin,
        size
      }, className)
    }, (0, _generateDataAttr.generateDataAttr)(this.props, ['skin', 'size']), {
      "data-hook": dataHook,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 7
      }
    }), children ? ( /*#__PURE__*/_react.default.cloneElement(children, {
      size: childSize,
      width: childSize,
      height: childSize
    })) : /*#__PURE__*/_react.default.createElement(_ThemeProviderConsumerBackwardCompatible.ThemeProviderConsumerBackwardCompatible, {
      defaultIcons: {
        CloseButton: {
          small: _system.Close,
          medium: _system.CloseLarge,
          large: _system.CloseLarge
        }
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 11
      }
    }, _ref => {
      var {
        icons
      } = _ref;
      return this._renderCloseIcon(icons.CloseButton[size], size);
    }));
  }
}
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = {
  /** render as some other component or DOM tag */
  as: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.string]),
  /** additional css classes */
  className: _propTypes.default.string,
  /** Used for passing any wix-style-react icon. For external icon make sure to follow ux sizing guidelines */
  children: _propTypes.default.node,
  /** skins of closebutton */
  skin: _propTypes.default.oneOf(['standard', 'standardFilled', 'light', 'lightFilled', 'dark', 'transparent']),
  /** size of closebutton */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /** Click event handler  */
  onClick: _propTypes.default.func,
  /** applies disabled styles */
  disabled: _propTypes.default.bool,
  /** string based data hook for testing */
  dataHook: _propTypes.default.string
};
CloseButton.defaultProps = {
  skin: 'standard',
  size: 'small',
  disabled: false
};
var _default = exports.default = CloseButton;
//# sourceMappingURL=CloseButton.js.map